import type { ZodError } from '@vy/utils';

export const serializeZodParseErrors = (error: ZodError) => {
  const issues = error.issues;
  const errors: string[] = [];
  for (const issue of issues) {
    const fullPath = issue.path.join('.');
    const errorMessage = `${fullPath}: ${issue.message}`;
    errors.push(errorMessage);
  }

  return errors;
};

export const getDisplayableZodParseErrors = (error: ZodError) => {
  const errors = serializeZodParseErrors(error);

  return errors.join('\n');
};
